module.exports = __webpack_public_path__ + "static/media/uport-icon-white.6cfca76f.svg";